import { Seat, BookedSeat, KeyText, KeyWrapper } from './seat-picker-styles'

const SeatPickerKey = () => {
  return (
    <>
      <KeyWrapper>
        <BookedSeat />
        <KeyText>Booked</KeyText>
        <Seat />
        <KeyText>Available</KeyText>
      </KeyWrapper>
    </>
  )
}

export default SeatPickerKey
